const initState = {
    DefaultPageView: "Grid View",
    PaginationDefaultRows: "10"
};
const SettingsReducer = (state = initState,action) => {
    if(['PaginationDefaultRows','DefaultPageView','GridView'].includes(action.type)){
        return {...state , [action.type] :action.payload};
    } else if(action.type === 'Settings'){
        if(action.payload.length > 0){
             let data = {};
             action.payload.map(item => {
                data = {...data,[item.type] :item.payload}
             })
            return {...state , ...data}
        }
    }
    else if(action.type === 'SettingsAll'){
        return action.payload
    }
    else if(action.type === 'SubmissionAuto'){
        return action.payload
    }
    else if(action.type === 'PageSetting'){
        return action.payload
    }
    else {
        return state;
    }
}

export default SettingsReducer